import { render, staticRenderFns } from "./StructureLink.vue?vue&type=template&id=418ca30b"
import script from "./StructureLink.vue?vue&type=script&lang=js"
export * from "./StructureLink.vue?vue&type=script&lang=js"
import style0 from "./StructureLink.vue?vue&type=style&index=0&id=418ca30b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports